import CalculationService from "src/services/calculationService";
import {Configuration} from "src/types/configuration";
import ConfiguratorService from "src/services/configuratorService";

const useCalculationService = (initConfiguration: Configuration, configuratorService: ConfiguratorService) => {
    return new CalculationService(initConfiguration, configuratorService);
};

export default useCalculationService;